import { CentralizedSliderBase, SectionContainerBase } from "@reusejs/react";
import LeftArrowSvg from "../../Icons/LeftArrowSvg";
import RightArrowSvg from "../../Icons/RightArrowSvg";
import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/solid";

export interface AlliancesSliderComponentProps {
  elements: React.ReactNode[];
  slide: boolean;
}

export function AlliancesSliderComponent(props: AlliancesSliderComponentProps) {
  const LeftArrow = (props: any) => {
    return <div></div>;
  };

  const RightArrow = (props: any) => {
    return <div></div>;
  };

  return (
    <div className="w-full md:max-w-screen-xl">
      <CentralizedSliderBase
        centralizedSliderBaseClasses={{
          layout: "w-full",
        }}
        gap={20}
        slidesPerView={1}
        centeredSlides={true}
        loop={props.slide == true ? true : false}
        hideArrow={false}
        renderArrowLeft={LeftArrow}
        renderArrowRight={RightArrow}
        autoPlay={2000}
      >
        {props.elements}
      </CentralizedSliderBase>
    </div>
  );
}
